export default __webpack_public_path__ + "static/media/Pretendard-ExtraBold.82ea4400.woff";